<script>
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import AddEdit from "./addedit.vue";
import satdosyazarfteslim from "@/models/satdosyazarfteslim";
import zarfalindibelgesi from "./zarfalindibelgesi.vue";
import komisyonateslim from "./komisyonateslim.vue";

export default {
  props: ["satdosyaId"],
  mixins: [apibtoast, apigeneric, satdosyazarfteslim],
  page: {
    title: "Teklif Veren Firmalar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    AddEdit,
    zarfalindibelgesi,
    komisyonateslim,
  },
  data() {
    return {
      title: this.$t("satdosyazarfteslim.Title"),
      items: [
        {
          text: "",
          href: "/",
        },
        {
          text: "",
          active: true,
        },
        {
          text: this.$t("satdosyazarfteslim.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: [],
      satdosya: {},
      DataUpdate: "",
      AddEdit: "",
      islem: 0,
      SiradakiNo: 1,
      Sno: 1,
      FormData: {},
    };
  },
  methods: {
    Get() {
      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
        this.satdosya = res.Data;
      });

      this.ActionsFilterGet({
        Service: "SatDosyaZarfTeslim",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId + "&Asc=Sirano",
      }).then((res) => {
        this.TableData = res.Data;

        this.Page.PageDataSize = res.TotalCount;

        if (res.Data.length > 0) {
          this.SiradakiNo = this.TableData[res.TotalCount - 1].Sirano;
        } else {
          this.SiradakiNo = 0;
        }

        this.$emit("aktif_menu_title", this.$t("satdosyazarfteslim.Title"));
      });

      this.ActionsSabitGet(201).then((res) => {
        this.OlcuBirimleri = [];

        for (var i = 0; i < res.Data.length; i++) {
          this.OlcuBirimleri.push({
            Id: res.Data[i].Id,
            Value: res.Data[i].Value,
          });
        }
      });
    },

    formkontrol() {
      this.satdosyazarfteslimData.Sirano = this.SiradakiNo + 1;

      this.satdosyazarfteslimData.Firmaid = null;
      this.satdosyazarfteslimData.Personelid = "";
      this.satdosyazarfteslimData.Teslimtarihsaat = "";

      this.DataUpdate = this.satdosyazarfteslimData;

      this.AddEdit = "Add";
    },

    SatDosyaUpdate() {
      this.Update("satdosya", this.satdosya);
    },
    DosyaFirmaDelete(FirmaId) {
      this.ActionsDeletePut({
        Service: "SatDosyaFirma/DeleteSatDosyaFirmaByDosyaFirmaTurId?dosyaid=" + this.satdosyaId + "&firmaid=" + FirmaId + "&firmaturu=3",
      }).then((res) => {
        if (res) {
          //     console.log(res);
        }
      });
    },
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-sm-12">
              <div class="row mb-2">
                <div class="col-sm-3">
                  <b-form-input v-model="satdosya.Zarfkomtestutanaktarih" @input="SatDosyaUpdate()" id="date" type="datetime-local"></b-form-input>
                </div>
                <div class="col-sm-9">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" v-b-modal.komisyonateslim @click="islem = 3"><i class="mdi mdi-file-export-outline me-1"></i>{{ $t("satdosyazarfteslim.Page.KomisyonTutanak") }}</button>

                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.satdosyazarfteslim @click="formkontrol()"><i class="mdi mdi-plus-box-multiple me-1"></i>{{ $t("satdosyazarfteslim.Page.TeklifEkle") }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-light">
                <tr>
                  <th>{{ $t("satdosyazarfteslim.Table.Sirano") }}</th>
                  <th>{{ $t("satdosyazarfteslim.Table.Firmaid") }}</th>
                  <th>{{ $t("satdosyazarfteslim.Table.Personelid") }}</th>
                  <th>{{ $t("satdosyazarfteslim.Table.Teslimtarihsaat") }}</th>
                  <th style="width: 85px; text-align: center;">{{ $t("satdosyazarfteslim.Table.Islem") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="Data in TableData" :key="Data.Id">
                  <td scope="row">{{ Data.Sirano }}</td>
                  <td scope="row">{{ Data.Firmaadi }}</td>
                  <td scope="row">{{ Data.Adsoyad }}</td>

                  <td scope="row">
                    {{ Data.Teslimtarihsaat | formatDateTime }}
                  </td>
                  <td style="width: 85px; text-align: center;">
                    <b-button-group>
                      <b-button @click="(DataUpdate = Data), (islem = 2)" v-tooltip="$t('satdosyazarfteslim.Table.AlindiBelgesi')" v-b-modal.zarfalindibelgesi variant="success">
                        <i class="far fa-print"></i>
                      </b-button>
                      <b-button @click="(DataUpdate = Data), (AddEdit = 'Edit'), (islem = 1)" v-b-modal.satdosyazarfteslim v-tooltip="$t('satdosyazarfteslim.Table.Duzelt')" variant="primary">
                        <i class="far fa-pencil-alt"></i>
                      </b-button>
                      <b-button @click="Delete('satdosyazarfteslim', Data.Id), DosyaFirmaDelete(Data.Firmaid)" v-tooltip="$t('satdosyafirma.Table.Sil')" variant="danger">
                        <i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
          </div>

          <AddEdit v-show="islem == 1" :Id="DataUpdate" :AddEdit="AddEdit" :satdosyaId="satdosyaId" @TableUpdate="Get" />

          <zarfalindibelgesi v-show="islem == 2" :Id="DataUpdate" :AddEdit="AddEdit" :satdosyaId="satdosyaId" @TableUpdate="Get" />

          <komisyonateslim v-show="islem == 3" :Id="TableData" :AddEdit="AddEdit" :satdosyaId="satdosyaId" @TableUpdate="Get" />
        </div>
      </div>
    </div>
  </div>
</template>
